const feed_en = require('./feed.json')
export default feed_en